import { mapExperienceToBookingView } from 'lib/experiences/experienceUtils'
import { fillArray } from 'lib/array/arrayUtils'
import { useCallback, useMemo } from 'react'
import * as React from 'react'
import ExperienceTile from '../ExperienceTiles/ExperienceTile'
import ExperienceTileSkeletonLoader from '../ExperienceTiles/ExperienceTileSkeletonLoader'
import variables from 'styles/vendor/bootstrap/variables'
import { getExperienceOfferPageURL } from 'lib/offer/offerPageURL'
import type { ArrowDirection } from 'LuxKit/Carousel/CardCarousel'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import useTrackExperienceOfferEvent from 'contexts/support/useTrackExperienceOfferEvent'

const layoutContainerGutter = variables.gutterWidth / 2

interface Props {
  experiences: Array<App.ExperienceOffer | undefined>
  listFetching?: boolean
  className?: string
  pageSize?: number
  gutterSize?: number
}

function ExperienceListTileCarousel({
  experiences,
  listFetching,
  className,
  pageSize = 4,
  gutterSize = layoutContainerGutter,
}: Props) {
  const views = useMemo(() => {
    return experiences.map(exp => exp ? mapExperienceToBookingView(exp) : undefined)
  }, [experiences])

  const trackEvent = useTrackExperienceOfferEvent()

  const handleArrowClick = useCallback((e: React.MouseEvent<HTMLButtonElement>, direction: ArrowDirection) => {
    if (direction === 'right') {
      trackEvent('CAROUSEL_NEXT_CLICKED')
    } else {
      trackEvent('CAROUSEL_PREV_CLICKED')
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps -- trackEvent is stable
  }, [])

  return (
    <CardCarousel pageSize={pageSize} width="75%" gutterSize={gutterSize} className={className} onArrowClick={handleArrowClick}>
      {listFetching && fillArray(pageSize).map((_, index) => <ExperienceTileSkeletonLoader key={index} />)}
      {!listFetching && views.map((expView, index) => <React.Fragment key={expView?.id ?? index}>
        {!expView && <ExperienceTileSkeletonLoader />}
        {expView && (
          <ExperienceTile
            key={expView.id}
            to={getExperienceOfferPageURL(expView.originalExperience)}
            experience={expView}
            position={index}
          />
        )}
      </React.Fragment>)}
    </CardCarousel>
  )
}

export default ExperienceListTileCarousel
